
































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ManagementManagedServicesData } from '@/modules/tickets/requirement/management-managed-services/domain/management-managed-services-data';

@Component({
    name: 'management-managed-services-ticket-confirmation',
})
export default class ManagementManagedServicesTicketConfirmation extends Vue {
    @Prop({ required: true })
    generalInformation!: ManagementManagedServicesData;

    private isFormValid: boolean = true;

    private isCreatingTicket: boolean = false;

    sendRequirementTicket() {
        this.$emit('sendRequirementTicket');
    }

    previousStep() {
        this.$emit('previousStep');
    }

    reset() {
        this.$emit('reset');
    }
}
